export const fourRetailConfiguration = {
  four_retail_configurations: `4Retail configurations`,
};
